/**
 * AP-41 (5.2) — „Einstellungen → Verträge": die für den Betrieb geltenden Dokumente mit Stand,
 * Annehmen / Kenntnis / Widerspruch und dem Verlauf aller Zustimmungen. Seit Nachtrag 1 dazu
 * „Wer nimmt an?".
 */
import { useTranslation } from 'react-i18next'
import { FileSignature } from 'lucide-react'
import { pageWide } from '@/lib/form-styles'
import { useVertraege } from '@/lib/vertraege'
import { AnnahmeDurch, useVertragsListe, VertragsKarte, VertragsVerlauf } from '@/components/vertraege/Vertraege'

export default function VertraegePage() {
  const { t } = useTranslation()
  const { liste, fehler, erledigt } = useVertragsListe()
  const firma = useVertraege((s) => s.status?.companyName) ?? ''

  return (
    <div className={pageWide}>
      <div>
        <h1 className="flex items-center gap-2 text-2xl font-bold text-foreground">
          <FileSignature size={22} /> {t('contracts.titel')}
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">{t('contracts.untertitel')}</p>
      </div>
      {fehler && <div className="rounded-md border border-destructive/30 bg-destructive/10 px-4 py-3 text-sm text-destructive">{fehler}</div>}
      <AnnahmeDurch />
      {liste && (
        <>
          {liste.dokumente.length === 0 ? (
            <p className="text-sm text-muted-foreground">{t('contracts.keine')}</p>
          ) : (
            <div className="grid gap-4 lg:grid-cols-2">
              {liste.dokumente.map((d) => (
                <VertragsKarte key={d.documentId} dok={d} companyName={firma} onErledigt={() => void erledigt()} />
              ))}
            </div>
          )}
          <section>
            <h2 className="mb-3 text-lg font-semibold text-foreground">{t('contracts.verlauf')}</h2>
            <VertragsVerlauf liste={liste} />
          </section>
        </>
      )}
    </div>
  )
}
